// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__BeqUL","container":"styles_container__2aat_","title":"styles_title__1HD77","wrapper":"styles_wrapper__3dt3X","answer":"styles_answer__fYY86"};